import { render, staticRenderFns } from "./InvitationLetter.vue?vue&type=template&id=4dca3d83&scoped=true"
import script from "./InvitationLetter.vue?vue&type=script&lang=js"
export * from "./InvitationLetter.vue?vue&type=script&lang=js"
import style0 from "./InvitationLetter.vue?vue&type=style&index=0&id=4dca3d83&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dca3d83",
  null
  
)

export default component.exports